import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import { Dialog } from '@totalsoft/rocket-ui';
import { BackdropCustom, DialogButton, DialogTitle } from './DocumentsStyles';
import DocumentsExportHistoryContainer from './DocumentsExportHistoryContainer';

const DocumentUploadHistoryModal = ({ fileId, onCloseDocumentUploadHistoryModal }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      id='documents-history-dialog'
      open={true}
      onClose={onCloseDocumentUploadHistoryModal}
      aria-labelledby='subsidies-dialog-title'
      fullWidth
      maxWidth={'md'}
      BackdropComponent={BackdropCustom}
      showX={false}
      disableBackdropClick
      disableEscapeKeyDown
      actionsProps={{ sx: theme => ({ px: theme.spacing(3), pb: theme.spacing(2) }) }}
      title={<DialogTitle>{t('OfferEdit.Documents.History.Title')}</DialogTitle>}
      content={
        <>
          <Dialog
            id='confirmation-dialog'
            showX={false}
            disableBackdropClick
            disableEscapeKeyDown
            actionsProps={{ sx: theme => ({ px: theme.spacing(3), pb: theme.spacing(2) }) }}
            title={t('OfferEdit.Documents.History.Title')}
            actions={
              <DialogButton
                id={'commissionsCard_subsidiesModal_cancelBtn'}
                color='primary'
                variant='contained'
                onClick={onCloseDocumentUploadHistoryModal}
              >
                {t('OfferEdit.Subsidies.ConfirmationDialog.CancelButton')}
              </DialogButton>
            }
          />
          <DocumentsExportHistoryContainer fileId={fileId} isForExport={false} />
        </>
      }
      actions={
        <DialogButton
          id={'commissionsCard_subsidiesModal_closeBtn'}
          color='primary'
          variant='contained'
          onClick={onCloseDocumentUploadHistoryModal}
        >
          {t('Close')}
        </DialogButton>
      }
    />
  );
};

DocumentUploadHistoryModal.propTypes = {
  fileId: PropTypes.string.isRequired,
  onCloseDocumentUploadHistoryModal: PropTypes.func.isRequired
};
export default DocumentUploadHistoryModal;
